import { render, staticRenderFns } from "./Regis.vue?vue&type=template&id=af77d6d2&"
import script from "./Regis.vue?vue&type=script&lang=js&"
export * from "./Regis.vue?vue&type=script&lang=js&"
import style0 from "./Regis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports